import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import { isFeatureEnabled } from '@/vuex/modules/featureToggles.module'

const SET_DATA = 'SET_DATA'

const _state = {
}

const _getters = {
  canUseQuickRating: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-quick-rating')
  },
  getLike: (state) => {
    return (id) => {
      return state[id]?.like || false
    }
  },
  getDislike: (state) => {
    return (id) => {
      return state[id]?.dislike || false
    }
  },
  getIsFeedbackSubmitted: (state) => {
    return (id) => {
      return state[id]?.isFeedbackSubmitted || false
    }
  },
}

const mutations = {
  [SET_DATA](state, { id, data }) {
    // Use Vue.set so new properties become reactive.
    // Direct assignment won't update the UI in Vue2.
    Vue.set(state, id, {
      ...state[id],
      ...data,
    })
  },
}

const actions = {
  setDataAction({ commit }, { id, data }) {
    try {
      if (!id) return

      commit(SET_DATA, { id, data })
    } catch (error) {
      Sentry.captureException(error)
    }
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
